// extracted by mini-css-extract-plugin
export default {"loader":"MyLoader_loader__nuT+h"};